import _classCallCheck from "/var/www/html/git/naati_pte/web_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/www/html/git/naati_pte/web_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/www/html/git/naati_pte/web_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/var/www/html/git/naati_pte/web_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import EventEmitter from './event-emitter.js';
export var BasePlugin = /*#__PURE__*/function (_EventEmitter) {
  _inherits(BasePlugin, _EventEmitter);
  var _super = _createSuper(BasePlugin);
  function BasePlugin(options) {
    var _this;
    _classCallCheck(this, BasePlugin);
    _this = _super.call(this);
    _this.subscriptions = [];
    _this.options = options;
    return _this;
  }
  _createClass(BasePlugin, [{
    key: "onInit",
    value: function onInit() {
      // Overridden in plugin definition
      return;
    }
  }, {
    key: "init",
    value: function init(wavesurfer) {
      this.wavesurfer = wavesurfer;
      this.onInit();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.emit('destroy');
      this.subscriptions.forEach(function (unsubscribe) {
        return unsubscribe();
      });
    }
  }]);
  return BasePlugin;
}(EventEmitter);
export default BasePlugin;